import Root from "./root-wrapper"
import "./src/css/main.scss"
import "./src/css/tailwind.css"

export const wrapRootElement = Root
